<div
  style="height: 100%; width: 100%"
  class="loading loading--large flex flex--column flex--justify-content-around flex--align-items-center"
>
  <div class="header header--md">Redirecting...</div>
</div>
